import {ReactElement, ReactNode} from 'react'
import {Spinner} from 'grommet'
import styled from 'styled-components'

type Size = 'small' | 'medium' | 'large'

export interface Props {
  isLoading?: boolean
  children: ReactNode | Array<ReactNode>
}

const Wrapper = styled.span`
  display: flex;
  align-items: center;
`

const LoadingIndicator = styled.span`
  padding-left: 0.5em;
`

const FontSizeSpinner = styled(Spinner)`
  width: 1em;
  height: 1em;
`

/**
 * Usage:
 *
 * ```
 * import {TextWithLoader} from '@mindthecoin/shiny'
 * ```
 */
function Button({children, isLoading}: Props): ReactElement {
  return (
    <Wrapper>
      {children}
      {isLoading ? (
        <LoadingIndicator>
          <FontSizeSpinner color="black" message="A carregar" />
        </LoadingIndicator>
      ) : null}
    </Wrapper>
  )
}

export default Button
